import { createSelector } from "@ngrx/store";
import { SignaturesState } from "./signatures.interface";
import {
  CHANGE_SIGNATURE_SUCCESS,
  GET_SIGNATURES_SUCCESS,
  INSTALL_SIGNATURE_SUCCESS,
  REINSTALL_SIGNATURES_FAILURE,
  REINSTALL_SIGNATURES_SUCCESS,
  REMOVE_SIGNATURE_SUCCESS,
  REORDER_SIGNATURES,
  REORDER_SIGNATURES_SUCCESS,
  SignaturesActions,
  UNINSTALL_SIGNATURE_SUCCESS,
} from "./signatures.actions";

export const initialState: SignaturesState = {
  signatures: null,
  isFirstInstallation: false,
};

export function signaturesReducer(
  state: SignaturesState = initialState,
  action: SignaturesActions,
): SignaturesState {
  switch (action.type) {
    case GET_SIGNATURES_SUCCESS:
      return {
        ...state,
        signatures: action.payload,
      };
    case REMOVE_SIGNATURE_SUCCESS:
      return {
        ...state,
        signatures: state.signatures.filter(
          (signature) => signature.templateId !== action.payload,
        ),
      };
    case INSTALL_SIGNATURE_SUCCESS:
      return {
        ...state,
        signatures: state.signatures.map((signature) =>
          signature.templateId === action.payload
            ? { ...signature, numberOfInstallations: 1 }
            : signature,
        ),
        isFirstInstallation: action.isFirstInstallation,
      };
    case UNINSTALL_SIGNATURE_SUCCESS:
      return {
        ...state,
        signatures: state.signatures.map((signature) =>
          signature.templateId === action.payload
            ? { ...signature, numberOfInstallations: 0 }
            : signature,
        ),
      };
    case CHANGE_SIGNATURE_SUCCESS:
      return {
        ...state,
        signatures: state.signatures.map((signature) =>
          signature.templateId === action.payload.templateId
            ? {
                ...signature,
                name: action.payload.body,
                content: action.payload.parsedBody,
              }
            : signature,
        ),
      };
    case REORDER_SIGNATURES:
      if (!state.signatures) {
        return state;
      }
      const reorderedList = action.payload
        .map((id) => state.signatures.find((sig) => sig.templateId === id))
        .filter((sig): sig is NonNullable<typeof sig> => !!sig);
      return { ...state, signatures: reorderedList };
    case REINSTALL_SIGNATURES_SUCCESS:
      return state;
    case REINSTALL_SIGNATURES_FAILURE:
      return state;
    case REORDER_SIGNATURES_SUCCESS:
      return state;
    default: {
      return state;
    }
  }
}

export const getSignaturesRootState = (state: {
  signatures: SignaturesState;
}): SignaturesState => state.signatures;
export const getIsFirstInstallation = (state: {
  signatures: SignaturesState;
}): boolean | undefined => state.signatures?.isFirstInstallation;
export const getSignaturesState = (state: SignaturesState) => state.signatures;

export const getSignaturesSelector = createSelector(
  getSignaturesRootState,
  getSignaturesState,
);
